import { render, staticRenderFns } from "./ViewResults.vue?vue&type=template&id=830b43ac&"
import script from "./ViewResults.vue?vue&type=script&lang=js&"
export * from "./ViewResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports